import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-ubs-blog-related',
  templateUrl: './ubs-blog-related.component.html',
  styleUrls: ['./ubs-blog-related.component.scss']
})
export class UbsBlogRelatedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
